import { formatLocalDateToUTCDate } from "../../mp-core/helpers/formatters/date"
import { VALUE_SEPARATOR } from "../../snapcourse/authoring/components/SnapCourseConfigForm/constants"
import { REQUEST_ORG_FILTERS_MAP } from "../constants/api"
import { FiltersState } from "../states"
import {
  RequestDateRangeFilters,
  RequestOrgFilters,
  RequestProgramFilters,
  RequestFilters
} from "../types/api"

export const getRequestOrgFilters = (
  filters: FiltersState = {}
): RequestOrgFilters => {
  return Object.entries(REQUEST_ORG_FILTERS_MAP).reduce(
    (acc, [filterKey, requestKey]) => ({
      ...acc,

      ...(filters[filterKey]?.length && {
        [requestKey]: filters[filterKey].join(",")
      })
    }),
    {} as RequestOrgFilters
  )
}

export const getRequestDateFilters = (
  filters: FiltersState = {}
): RequestDateRangeFilters => {
  const dateRange = filters.date

  if (!dateRange?.[0] || !dateRange?.[1]) {
    return null
  }

  const formattedStartDate = formatLocalDateToUTCDate({
    date: dateRange[0],
    withTime: true,
    withSeconds: true,
    useStartOfDay: true,
    useISOFormat: true
  })

  const formattedEndDate = formatLocalDateToUTCDate({
    date: dateRange[1],
    withTime: true,
    withSeconds: true,
    useEndOfDay: true,
    useISOFormat: true
  })

  return {
    dateRange: [formattedStartDate, formattedEndDate].join(",")
  }
}

export const getRequestProgramFilters = (
  filters: FiltersState = {}
): RequestProgramFilters => {
  if (!filters.test?.length) {
    return null
  }

  const { programs, subjects } = filters.test.reduce(
    (acc, value) => {
      const [program, subject] = value.split(VALUE_SEPARATOR)

      return {
        ...acc,
        programs:
          program && !acc.programs.includes(program)
            ? [...acc.programs, program]
            : acc.programs,
        subjects: subject ? [...acc.subjects, subject] : acc.subjects
      }
    },
    { programs: [], subjects: [] }
  )

  // Get all programs and subjects separately.
  return {
    program: programs.join(",") || undefined,
    subject: subjects.join(",") || undefined
  }
}

export const getRequestFilters = (
  filters: FiltersState = {}
): RequestFilters => {
  return {
    ...(getRequestOrgFilters(filters) ?? {}),
    ...(getRequestDateFilters(filters) ?? {}),
    ...(getRequestProgramFilters(filters) ?? {})
  }
}
